<template>
  <v-card flat :style="`height: ${this.height}px`" >
    <component
      :is="data.component"
      :data="getData"
      :mode="getMode"
      :parentActions="getActions"
      @close="(payload) => {$emit('close', payload)}"
      @edit="(payload) => {$emit('edit', payload)}"
    />
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import ModalComponents from '@/nms/components/modal/modal-import.ts'

// Типы для пропсов
interface ModalData {
  data?: any
  mode?: string
  title?: string
  parentActions?: Record<string, any>
  [key: string]: any
}

export default Vue.extend({
  name: 'MODAL',

  components: {
    ...ModalComponents.modules
  },

  props: {
    data: {
      type: Object as () => ModalData,
      default: () => ({})
    },
  },

  data(): {
    height: number
  } {
    return {
      height: 0,
    }
  },

  computed: {
    getData(): any {
      return this.data.data
    },

    getMode(): string | undefined {
      return this.data.mode
    },

    getActions(): Record<string, any> {
      return this.data.parentActions || {}
    },
  },

  mounted(): void {
    const parentEl = this.$parent?.$el as HTMLElement
    if (parentEl) {
      this.height = this.data.title 
        ? parentEl.clientHeight * 0.96 
        : parentEl.clientHeight
    }
    console.log('MODAL', 'data', this.data)
  },
})
</script>

<style scoped lang="less">

</style>
